const Contacts = () => {
  return (
    <main className="section-contacts contacts">
      <div className="container ">
        <h1 className="title-1">Contacts</h1>
        <div className="content-list-my">
          <div className="content-list__item">
            <h2 className="title-2">Telegram</h2>
            <p>
              <a
                href="https://t.me/LeonidWebUI"
                target="_blank"
                rel="noopener noreferrer"
              >
                LeonidWebUI
              </a>
            </p>
          </div>
          <div className="content-list__item">
            <h2 className="title-2">Email</h2>
            <p>
              <a href="mailto:leonideko1@gmail.com">leonideko1@gmail.com</a>
            </p>
          </div>
          <div className="content-list__item">
            <h3 className="title-2">LinkedIn</h3>
            <p>
              <a
                href="https://www.linkedin.com/in/leonid-shamarin/"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn Profile
              </a>
            </p>
          </div>
          <div className="content-list__item">
            <h3 className="title-2">GitHub</h3>
            <p>
              <a
                href="https://github.com/LeonidShamarin"
                target="_blank"
                rel="noopener noreferrer"
              >
                GitHub Profile
              </a>
            </p>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Contacts;
